import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { rotuloCampo } from './regrasCadastro';

// Rola até o campo pelo `name` do input (texto, select, data e liga/desliga têm).
function rolarAteCampo(codigo) {
  const input = document.querySelector(`[name="${CSS.escape(codigo)}"]`);
  const alvo = input?.closest('.MuiFormControl-root, .MuiFormControlLabel-root') ?? input;
  alvo?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

/**
 * Campos obrigatórios que o backend recusou no envio final (CommandResult `data.faltando`,
 * com os códigos): marca cada um em vermelho, monta a mensagem com os rótulos da tela e
 * rola até o primeiro. Quem decide o que é obrigatório continua sendo o backend.
 */
export default function useCamposFaltando(campos) {
  const { t, i18n } = useTranslation();
  const [faltando, setFaltando] = useState([]);

  /** Lê o erro do envio. Devolve a mensagem pronta, ou null se não for de campos faltando. */
  const registrar = (erro) => {
    const corpo = erro?.response?.data ?? erro;
    const codigos = corpo?.data?.faltando ?? corpo?.faltando;
    if (!Array.isArray(codigos) || codigos.length === 0) return null;
    setFaltando(codigos);
    const rotulos = codigos.map((codigo) => {
      const campo = campos.find((c) => c.codigo === codigo);
      return campo ? rotuloCampo(campo, t, i18n.language) : codigo;
    });
    // Depois do re-render (o formulário pode ter trocado pelo spinner durante o envio)
    setTimeout(() => rolarAteCampo(codigos[0]), 150);
    return t('validacao.camposFaltando', { campos: rotulos.join(', ') });
  };

  /** O campo sai da lista assim que a pessoa mexe nele. */
  const limpar = (codigos) => {
    if (faltando.some((c) => codigos.includes(c))) setFaltando((atual) => atual.filter((c) => !codigos.includes(c)));
  };

  const erroDe = (codigo) => (faltando.includes(codigo) ? t('validacao.campoObrigatorio') : null);

  return { registrar, limpar, erroDe };
}
